import {type PayloadAction, createSlice, current} from "@reduxjs/toolkit";
import {type UserMessage} from "./types";
import {type WithState} from "../../store/utils";

export interface MessagesState {
  messages: UserMessage[];
}

export const initialState: MessagesState = {
  messages: []
};

export const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    displayUserMessage(state: MessagesState, action: PayloadAction<UserMessage>) {
      const currentState = current(state);
      const messageExists = currentState.messages.find(
        message => message.message?.trim() === action.payload?.message?.trim()
      );

      if (messageExists) {
        return;
      }

      state.messages = [...currentState.messages, action.payload];
    },
    deleteUserMessage(state: MessagesState, action: PayloadAction<UserMessage>) {
      state.messages = current(state).messages.filter(
        message => message.message.trim() !== action.payload.message.trim()
      );
    }
  }
});
export const {displayUserMessage, deleteUserMessage} = messagesSlice.actions;
export const selecteMessages = (state: WithState<MessagesState, "messages">) =>
  state.messages.messages;

export const messagesReducer = messagesSlice.reducer;
